/**
 * Unique symbol used to store type metadata.
 * 
 * @type {unique symbol}
 */
 export const TYPE_METADATA_SYMBOL: unique symbol = Symbol.for('$DSTypeMetadata');
